function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "print",
    d: "M7.34,18.66V16h9.33v2.67H7.34V18.66z M7.34,12V5.34h6.66V7c0,0.55,0.45,1,1,1h1.67v4H7.34z M19.13,13.13  c-0.26,0.25-0.67,0.24-0.92-0.02c-0.25-0.26-0.24-0.67,0.02-0.92c0.26-0.25,0.67-0.24,0.92,0.02c0.12,0.12,0.18,0.28,0.18,0.45  C19.33,12.84,19.26,13.01,19.13,13.13L19.13,13.13z M20.67,12.66c0-1.1-0.9-2-2-2h-0.67V8c-0.01-0.32-0.08-0.63-0.21-0.92  c-0.11-0.29-0.28-0.56-0.5-0.79L15.7,4.71c-0.23-0.22-0.5-0.39-0.79-0.5c-0.29-0.13-0.6-0.2-0.92-0.21h-7c-0.55,0-1,0.45-1,1v5.66  H5.34c-1.1,0-2,0.9-2,2V17c0.01,0.18,0.15,0.32,0.33,0.33h2.33V19c0,0.55,0.45,1,1,1h10c0.55,0,1-0.45,1-1v-1.67h2.33  c0.18-0.01,0.32-0.15,0.33-0.33v-4.33l0,0L20.67,12.66z",
    style: {
      fill: "rgb(84, 88, 90)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.e1e72a1b.svg";
export { ForwardRef as ReactComponent };